import {BusinessException} from '../../framework/message/BusinessException';
import {EMPackEntry} from './EMPackEntry';
import {EntityModification} from './EntityModification';

export class EntityModificationPack {
businessUnitCode: string;
domain: string;
emTime: number | null;
ems: EntityModification[];
entries: EMPackEntry[];
errors: BusinessException[];
order: number | null;
packUID: string;
status: string;
}

